import "core-js/modules/es6.function.name";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import VipBotton from "./vipBotton/vipBotton.vue";
import countDown from "./countDown/countDown.vue";
import backTrack, { VIP_CLOSE_TOAST } from "@/utils/backTrack";
import { sendMapEvent } from "@/utils/analytics";
import { clipTop, clipBottom } from "@/utils/pageFitMethod";
import { i18n } from "@/i18n/i18n-setup";
import GeneralUtilsHelper from "@/utils/generalUtils";
import EventBus from "@/utils/eventBus";
import vipGetReportBtn from "@/components/vipGetReportBtn/vipGetReportBtn.vue";
import VideoPlayer from "@/components/videoPlayer/videoPlayer.vue";
import { getLang } from "@/api/utils/apiHelper";
import { isIos } from "@/utils/lodash";

var Vipcenter =
/*#__PURE__*/
function (_Vue) {
  _inherits(Vipcenter, _Vue);

  function Vipcenter() {
    var _this;

    _classCallCheck(this, Vipcenter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Vipcenter).apply(this, arguments));
    _this.initialTime = 0;
    _this.timer = null;
    _this.isShowCloseIcon = false;
    _this.showcloseToast = false;
    _this.type = "";
    _this.key = "";
    _this.byClick = false;
    _this.videoName = "";
    _this.imgVideoList = {
      single: _this.$remoteImg("video/vip_normal.mp4"),
      single_img: _this.$remoteImg("icons/vip/vip_all_index.jpg"),
      agingShutter: _this.$remoteImg("video/aging_shutter.mp4"),
      agingShutter_img: _this.$remoteImg("icons/vip/vip_as_index.jpg"),
      futureBaby: _this.$remoteImg("vip/future_baby_vip.png"),
      horoscope: _this.$remoteImg("vip/zodiac_vip.png"),
      ethnicity: _this.$remoteImg("vip/ethnicity_vip.png"),
      // horoscope: "",
      personalFutrue: _this.$remoteImg("vip/future_vip.png"),
      loveCompatibility: _this.$remoteImg("vip/love_compatibility_vip.png"),
      genderSwitch: _this.$remoteImg("vip/gender_vip.png"),
      palmPrint: _this.$remoteImg("video/palm_print_video.mp4"),
      palmPrint_img: _this.$remoteImg("vip/palmprint_firstframe.png"),
      love_consultant: _this.$remoteImg("vip/love_consultant_vip.png"),
      daily_palmistry: _this.$remoteImg("vip/daily_palmistry_vip.png"),
      wealth_forecast: _this.$remoteImg("vip/wealth_forecast.png"),
      zodiac_match: _this.$remoteImg("vip/zodiac_match_vip.png"),
      face_read: _this.$remoteImg("icons/face-reading/face_reading_vip.png"),
      elebrities: _this.$remoteImg("icons/face-reading/celebs_vip.png")
    };
    _this.warmTips = {
      agingShutter: i18n.t("vip_center_page.warmTips.agingShutter"),
      horoscope: i18n.t("vip_center_page.warmTips.horoscope"),
      futureBaby: i18n.t("vip_center_page.warmTips.futureBaby"),
      genderSwitch: i18n.t("vip_center_page.warmTips.genderSwitch"),
      palmPrint: i18n.t("vip_center_page.warmTips.palmPrint"),
      ethnicity: i18n.t("vip_center_page.warmTips.ethnicity"),
      loveCompatibility: i18n.t("vip_center_page.warmTips.loveCompatibility"),
      daily_palmistry: i18n.t("vip_center_page.warmTips.daily_palmistry"),
      personalFutrue: i18n.t("vip_center_page.warmTips.personalFutrue"),
      wealth_forecast: i18n.t("vip_center_page.warmTips.wealth_forecast"),
      love_consultant: i18n.t("vip_center_page.warmTips.love_consultant"),
      zodiac_match: i18n.t("vip_center_page.warmTips.zodiac_match"),
      face_read: i18n.t("vip_center_page.warmTips.face_reading")
    };
    return _this;
  } // private offerNum = 0;


  _createClass(Vipcenter, [{
    key: "clickClose",
    value: function clickClose() {
      var _this2 = this;

      if (this.type === "single" && !this.isShowCloseIcon) {
        return;
      }

      if (this.showcloseToast) {
        backTrack.listen({
          key: VIP_CLOSE_TOAST,
          fn: function fn() {
            _this2.hideVipToast();
          }
        });
        this.showCloseToast();
      } else {
        this.goBack();
      }
    }
  }, {
    key: "showCloseToast",
    value: function showCloseToast() {
      sendMapEvent("uia_vip_before_unload_dialog", {
        key: "show"
      });
      this.showVipToast({
        confirmFn: this.toastBuyVIP,
        cancelFn: this.goBack
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.initData();
      this.getVideoUrl();
      this.sendEvent("show");
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this3 = this;

      this.type = this.$route.query.type;
      this.key = this.$route.query.key;
      this.byClick = this.$route.query.byClick; // this.offerNum =
      //   this.type === "single" ? (this.$route.query as any).offerNum : 0;

      this.showcloseToast = this.$route.query.showToast;
      var closeIconShowTime = this.settingData && this.settingData.client && this.settingData.client.vip_config ? this.settingData.client.vip_config.vip_close_btn_delay_show_time : 2000;

      if (this.type === "single") {
        setTimeout(function () {
          _this3.isShowCloseIcon = true;
        }, closeIconShowTime);
      } else {
        this.isShowCloseIcon = true;
        this.byClick && setTimeout(this.buyVIP, 500);
      }
    }
  }, {
    key: "getVideoUrl",
    value: function () {
      var _getVideoUrl = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var videoType, videoNameStr, videoName;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                videoType = this.lunchConfig && this.lunchConfig.launch_vip_video_local_resource ? "local" : "online";
                videoNameStr = "";
                _context.t0 = this.type;
                _context.next = _context.t0 === "single" ? 5 : _context.t0 === "agingShutter" ? 7 : _context.t0 === "beauty_contest" ? 9 : _context.t0 === "futureBaby" ? 11 : _context.t0 === "loveCompatibility" ? 13 : _context.t0 === "palmPrint" ? 15 : _context.t0 === "genderSwitch" ? 17 : _context.t0 === "personalFutrue" ? 19 : 21;
                break;

              case 5:
                videoNameStr = "vip_all.mp4";
                return _context.abrupt("break", 22);

              case 7:
                videoNameStr = "age_shutter.mp4";
                return _context.abrupt("break", 22);

              case 9:
                videoNameStr = "beauty_contest.mp4";
                return _context.abrupt("break", 22);

              case 11:
                videoNameStr = "future_baby.mp4";
                return _context.abrupt("break", 22);

              case 13:
                videoNameStr = "love_compatibility.mp4";
                return _context.abrupt("break", 22);

              case 15:
                videoNameStr = "palm_print.mp4";
                return _context.abrupt("break", 22);

              case 17:
                videoNameStr = "gender_switch_vip.mp4";
                return _context.abrupt("break", 22);

              case 19:
                videoNameStr = "personality_future_vip.mp4";
                return _context.abrupt("break", 22);

              case 21:
                return _context.abrupt("return");

              case 22:
                if (!((this.type === "genderSwitch" || this.type === "personalFutrue") && videoNameStr)) {
                  _context.next = 29;
                  break;
                }

                _context.next = 25;
                return GeneralUtilsHelper.getVideoFileUrl(videoNameStr, videoType, true //强制只要那个类型
                );

              case 25:
                videoName = _context.sent;

                if (videoName) {
                  //有本地视频
                  this.videoName = videoName;
                  console.log("有本地视频 this.videoName", this.videoName);
                }

                _context.next = 34;
                break;

              case 29:
                if (!videoNameStr) {
                  _context.next = 34;
                  break;
                }

                _context.next = 32;
                return GeneralUtilsHelper.getVideoFileUrl(videoNameStr, videoType);

              case 32:
                this.videoName = _context.sent;
                console.log("this.videoName", this.videoName);

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getVideoUrl() {
        return _getVideoUrl.apply(this, arguments);
      }

      return getVideoUrl;
    }()
  }, {
    key: "sendEvent",
    value: function sendEvent(name) {
      var key = "";

      switch (this.key) {
        case "mian_vip":
          key = "uia_vip_mian";
          break;

        case "horoscope_tomorrow":
        case "horoscope_week":
        case "horoscope_month":
        case "horoscope_year":
          key = "uia_vip_horoscope";
          break;

        case "age":
          key = "uia_vip_age";
          break;

        case "future_baby":
          key = "uia_vip_future_baby";
          break;

        case "ethnicity":
          key = "uia_vip_ethnicity";
          break;

        case "person_future":
          key = "uia_vip_person_future";
          break;

        case "Palmistry":
          key = "uia_vip_Palmistry";
          break;

        case "Gender_Switch":
          key = "uia_vip_Gender_Switch";
          break;

        case "Love_Compatibility":
          key = "uia_vip_Love_Compatibility";
          break;

        case "Love_Consultant":
          key = "uia_vip_Love_Consultant";
          break;

        case "Wealth_Forecast":
          key = "uia_vip_Wealth_Forecast";
          break;

        case "Palm_Print":
          key = "uia_vip_Palm_Print";
          break;

        case "zodiac_match":
          key = "uia_vip_Zodiac_Match";
          break;

        case "face_read":
          key = "uia_vip_Face_Read";
          break;

        case "elebrities":
          key = "uia_vip_elebrities";
          break;

        default:
          key = "other";
      }

      if (this.key.includes("uia_vip_plan")) {
        key = this.key;
      }

      sendMapEvent(key, {
        key: name
      });
    }
  }, {
    key: "toastBuyVIP",
    value: function () {
      var _toastBuyVIP = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                sendMapEvent("uia_vip_before_unload_dialog", {
                  key: "click"
                });
                _context2.next = 4;
                return this.payVip();

              case 4:
                result = _context2.sent;

                if (result) {
                  sendMapEvent("uia_vip_before_unload_dialog", {
                    key: "buy"
                  });
                  sendMapEvent("uia_vip_buyway", {
                    key: "before_unload_dialog"
                  });
                  this.goBack();
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                } else {
                  _Toast(i18n.t("toast.purchase_failed"));
                } // const mock_data = {
                //   auto_renew: true,
                //   is_trial: false,
                //   product_id: "com.one.sub.1.month",
                //   purchase_timestamp: 1554964259951,
                //   service_type: "vip",
                //   sub_expire_timestamp: 1871121702000,
                //   transaction_id: "test_vip"
                // };
                // this.updateServiceList([mock_data]);
                // this.updateResultByName({name: "canShowSuccessToast", result: true});
                // this.goBack();


                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function toastBuyVIP() {
        return _toastBuyVIP.apply(this, arguments);
      }

      return toastBuyVIP;
    }()
  }, {
    key: "buyVIP",
    value: function () {
      var _buyVIP = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.sendEvent("click");
                _context3.next = 4;
                return this.payVip();

              case 4:
                result = _context3.sent;

                if (result) {
                  sendMapEvent("uia_vip_buyway", {
                    key: this.key
                  });
                  this.sendEvent("buy");
                  this.goBack();
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                } else {
                  _Toast(i18n.t("toast.purchase_failed"));
                } // const mock_data = {
                //   auto_renew: true,
                //   is_trial: false,
                //   product_id: "com.one.sub.1.month",
                //   purchase_timestamp: 1554964259951,
                //   service_type: "vip",
                //   sub_expire_timestamp: 1871121702000,
                //   transaction_id: "test_vip"
                // };
                // this.updateServiceList([mock_data]);
                // this.updateResultByName({name: "canShowSuccessToast", result: true});
                // this.goBack();


                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.log(_context3.t0);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function buyVIP() {
        return _buyVIP.apply(this, arguments);
      }

      return buyVIP;
    }()
  }, {
    key: "hideVipToast",
    value: function hideVipToast() {
      backTrack.destroy(VIP_CLOSE_TOAST);
      EventBus.$emit("vip-toast-show", {
        show: false
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this4 = this;

      clearInterval(this.timer);

      if (this.countTimes) {
        setTimeout(function () {
          _this4.initialTime = _this4.countTimes;
          _this4.timer = setInterval(function () {
            _this4.initialTime--;

            if (_this4.initialTime <= 0) {
              clearInterval(_this4.timer);

              _this4.showCloseToast();
            }
          }, 1000);
        }, 100);
      }

      backTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this4.clickClose();
        }
      });
      this.$nextTick(function () {
        console.log("vip mounted:", new Date().valueOf());
      });
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      clearInterval(this.timer);
    }
  }, {
    key: "goBack",
    value: function goBack() {
      this.hideVipToast();
      backTrack.destroy(this.$route.name);
      this.routerGoBack(-1);

      if (this.type !== "single") {
        this.updateVipCloseCount();
      }
    }
  }, {
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "isItaly",
    get: function get() {
      return getLang() === "it";
    }
  }, {
    key: "isEspanish",
    get: function get() {
      return getLang() === "es";
    }
  }, {
    key: "getText",
    get: function get() {
      return i18n.t("common.button.get_my_relust_upper_case");
    }
  }, {
    key: "readContainer",
    get: function get() {
      return this.type === "face_read" ? "face_read_container" : "";
    }
  }, {
    key: "readContainerAndroidStyle",
    get: function get() {
      return isIos() ? "" : this.type === "face_read" ? "paddingTop:" + this.androidStatusBarHeight + "px" : "";
    }
  }, {
    key: "titleList",
    get: function get() {
      return {
        single: i18n.t("vip_center_page.text_list.single.title"),
        agingShutter: i18n.t("vip_center_page.text_list.aging_shutter.title"),
        futureBaby: i18n.t("vip_center_page.text_list.future_baby.title"),
        horoscope: i18n.t("vip_center_page.text_list.horoscope.title"),
        ethnicity: i18n.t("vip_center_page.text_list.ethnicity.title"),
        personalFutrue: i18n.t("vip_center_page.text_list.personal_futrue.title"),
        loveCompatibility: i18n.t("vip_center_page.text_list.love_compatibility.title"),
        genderSwitch: i18n.t("vip_center_page.text_list.gender_switch.title"),
        palmPrint: i18n.t("vip_center_page.text_list.palmPrint.title"),
        love_consultant: i18n.t("vip_center_page.text_list.love_consultant.title"),
        daily_palmistry: i18n.t("vip_center_page.text_list.daily_palmistry.title"),
        wealth_forecast: i18n.t("vip_center_page.text_list.wealth_forecast.title"),
        zodiac_match: i18n.t("vip_center_page.text_list.zodiac_match.title"),
        face_read: i18n.t("vip_center_page.text_list.face_reading.title"),
        elebrities: i18n.t("vip_center_page.text_list.elebrities.title")
      };
    }
  }, {
    key: "videoShow",
    get: function get() {
      return this.type === "single" || this.type === "agingShutter" || this.type === "palmPrint" || (this.type === "genderSwitch" || this.type === "personalFutrue") && this.videoName !== "";
    }
  }, {
    key: "textList",
    get: function get() {
      return {
        single: [this.$t("vip_center_page.text_list.single.text_array[0]"), this.$t("vip_center_page.text_list.single.text_array[1]"), this.$t("vip_center_page.text_list.single.text_array[2]"), this.$t("vip_center_page.text_list.single.text_array[3]")],
        agingShutter: [this.$t("vip_center_page.text_list.aging_shutter.text_array[0]")],
        futureBaby: [this.$t("vip_center_page.text_list.future_baby.text_array[0]")],
        horoscope: [this.$t("vip_center_page.text_list.horoscope.text_array[0]"), this.$t("vip_center_page.text_list.horoscope.text_array[1]")],
        ethnicity: [this.$t("vip_center_page.text_list.ethnicity.text_array[0]")],
        personalFutrue: [this.$t("vip_center_page.text_list.personal_futrue.text_array[0]")],
        loveCompatibility: [this.$t("vip_center_page.text_list.love_compatibility.text_array[0]"), this.$t("vip_center_page.text_list.love_compatibility.text_array[1]")],
        genderSwitch: [this.$t("vip_center_page.text_list.gender_switch.text_array[0]")],
        palmPrint: [this.$t("vip_center_page.text_list.palmPrint.text_array[0]")],
        love_consultant: [this.$t("vip_center_page.text_list.love_consultant.text_array[0]")],
        daily_palmistry: [this.$t("vip_center_page.text_list.daily_palmistry.text_array[0]"), this.$t("vip_center_page.text_list.daily_palmistry.text_array[1]")],
        wealth_forecast: [this.$t("vip_center_page.text_list.wealth_forecast.text_array[0]")],
        zodiac_match: [this.$t("vip_center_page.text_list.zodiac_match.text_array[0]")],
        face_read: [this.$t("vip_center_page.text_list.face_reading.text_array[0]")],
        elebrities: [this.$t("vip_center_page.text_list.elebrities.text_array[0]")]
      };
    }
  }, {
    key: "countTimes",
    get: function get() {
      return this.type === "single" ? this.settingData && this.settingData.client && this.settingData.client.vip_config ? this.settingData.client.vip_config.vip_count_down_time / 1000 : 120 : 0; //ms单位
      // return 20000;
    }
  }, {
    key: "clipTop",
    get: function get() {
      return clipTop();
    }
  }, {
    key: "clipBottom",
    get: function get() {
      return clipBottom();
    }
  }, {
    key: "androidStatusBarHeight",
    get: function get() {
      return window.StatusBar.actualHeight;
    }
  }]);

  return Vipcenter;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], Vipcenter.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.ROUTER_REPLACE)], Vipcenter.prototype, "routerReplace", void 0);

tslib_1.__decorate([Action(types.PAY_BY_IAP)], Vipcenter.prototype, "payByIap", void 0);

tslib_1.__decorate([Action(types.SHOW_VIP_TOAST)], Vipcenter.prototype, "showVipToast", void 0);

tslib_1.__decorate([Mutation(types.HIDE_TOAST)], Vipcenter.prototype, "hideToast", void 0);

tslib_1.__decorate([Getter(types.GETTER_SETTING_DATA)], Vipcenter.prototype, "settingData", void 0);

tslib_1.__decorate([Action(types.PAY_VIP)], Vipcenter.prototype, "payVip", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_SERVICE_LIST)], Vipcenter.prototype, "updateServiceList", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_VIP_CLOSE_COUNT)], Vipcenter.prototype, "updateVipCloseCount", void 0);

tslib_1.__decorate([Getter(types.GETTER_LAUNCH_CONFIG)], Vipcenter.prototype, "lunchConfig", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], Vipcenter.prototype, "updateResultByName", void 0);

Vipcenter = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    VipBotton: VipBotton,
    countDown: countDown,
    vipGetReportBtn: vipGetReportBtn,
    VideoPlayer: VideoPlayer
  }
})], Vipcenter);
export default Vipcenter;